import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { StyledElement } from '@ui/types';

const StyledContainer = styled.div``;

export const Container: FunctionComponent<StyledElement> = ({
  children,
  className,
}) => <StyledContainer className={className}>{children}</StyledContainer>;

export const ColumnContainer = styled(Container)`
  display: flex;
  flex-direction: column;
`;

export const RowContainer = styled(Container)`
  display: flex;
  align-items: center;
`;

export const SpaceBetweenRowContainer = styled(RowContainer)`
  justify-content: space-between;
`;
